import React, { useCallback, useEffect, useState } from "react";
import { FaPlus } from "react-icons/fa";
import apiRequest from "../services/api";
import { useNavigate } from "react-router-dom";
import ExamAnalysisModal from "../components/ExamAnalysisModal";

const Result = () => {
  const [results, setResults] = useState([]);
  const [resultId, setResultId] = useState(null);
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const fetchResults = useCallback(async () => {
    try {
      const userString = localStorage.getItem("user");
      const storedUser = JSON.parse(userString);

      if (!storedUser?.username) {
        setResults([]);
        setError("Username not found. Please log in again.");
        return;
      }
      const data = await apiRequest(`users/results/${storedUser.username}`, {
        method: "GET",
      });

      if (data?.success && Array.isArray(data.data)) {
        setResults(data.data);

        setError("");
      } else {
        setResults([]);
        setError(data?.message || "No results found");
      }
    } catch (err) {
      console.error(err);
      setResults([]);
      setError(err.message || "Unexpected error occurred");
    }
  }, []);

  useEffect(() => {
    fetchResults();
  }, [fetchResults]);

  return (
    <div className="p-6">
      {/* Header */}
      <div className="flex flex-col md:flex-row justify-between items-start md:items-center mb-6 gap-4">
        <h2 className="text-3xl font-bold text-gray-800">My Results</h2>
      </div>

      {error && <p className="text-red-500 mb-4">{error}</p>}

      {/* Table */}
      <div className="overflow-x-auto rounded-lg shadow-lg">
        <table className="min-w-full border border-gray-200">
          <thead className="bg-blue-400 text-white">
            <tr>
              <th className="px-4 py-3 text-left">Date</th>
              <th className="px-4 py-3 text-left">Candidate</th>
              <th className="px-4 py-3 text-left">Exam Center</th>
              <th className="px-4 py-3 text-left">Exam Round</th>
              <th className="px-4 py-3 text-left">Total Score</th>
              <th className="px-4 py-3 text-left">Pass Mark</th>
              <th className="px-4 py-3 text-left">Status</th>
              <th className="px-4 py-3 text-left">Domain Analysis</th>
            </tr>
          </thead>
          <tbody>
            {results.length > 0 ? (
              results.map((r, i) => (
                <tr
                  key={r.id}
                  className={`${
                    i % 2 === 0 ? "bg-gray-50" : "bg-white"
                  }  cursor-pointer transition-colors duration-200`}
                >
                  <td className="px-4 py-2">{r.date}</td>
                  <td className="px-4 py-2">{r.user?.name}</td>
                  <td className="px-4 py-2">{r.center?.name}</td>
                  <td className="px-4 py-2">{r.round?.name}</td>
                  <td className="px-4 py-2">{r.mark}</td>
                  <td className="px-4 py-2">{r.cut}</td>
                  <td className="px-4 py-2 font-semibold">{r.decision}</td>
                  <td
                    className="px-4 py-2 font-semibold cursor-pointer text-blue-400 hover:text-blue-300"
                    onClick={() => {
                      setResultId(r.id);
                      setIsModalOpen(true);
                    }}
                  >
                    View Feedback
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="8" className="text-center py-6 text-gray-500">
                  {error || "No results found"}
                </td>
              </tr>
            )}
          </tbody>
        </table>

        <ExamAnalysisModal
          isOpen={isModalOpen}
          onClose={() => setIsModalOpen(false)}
          resultId={resultId}
        />
      </div>
    </div>
  );
};

export default Result;
